import { lazy } from 'react'
import { Redirect } from 'react-router-dom'


// ** Document title
const TemplateTitle = '%s - Vuexy React Admin Template'

// ** Default Route
const DefaultRoute = '/home'

// ** Merge Routes
const Routes = [

  {
    path: '/home',
    component: lazy(() => import('../../views/Home'))
  },

  {
    path: '/jbfAquatic',
    component: lazy(() => import('../../views/products/jbfAquatic'))
  },

  {
    path: '/jbfCattle',
    component: lazy(() => import('../../views/products/jbfCattle'))
  },

  {
    path: '/jbfCricket',
    component: lazy(() => import('../../views/products/jbfCricket'))
  },

  {
    path: '/jbfPoultry',
    component: lazy(() => import('../../views/products/jbfPoultry'))
  },

  {
    path: '/jbfSwine',
    component: lazy(() => import('../../views/products/jbfSwine'))
  },

  {
    path: '/selectAquatic',
    component: lazy(() => import('../../views/products/selectAquatic'))
  },

  {
    path: '/selectCattle',
    component: lazy(() => import('../../views/products/selectCattle'))
  },

  {
    path: '/selectCricket',
    component: lazy(() => import('../../views/products/selectCricket'))
  },

  {
    path: '/selectPoultry',
    component: lazy(() => import('../../views/products/selectPoultry'))
  },
  {
    path: '/selectSwine',
    component: lazy(() => import('../../views/products/selectSwine'))
  },

  {
    path: '/jumboPoultry',
    component: lazy(() => import('../../views/products/jumboPoultry'))
  },

  {
    path: '/jumboSwine',
    component: lazy(() => import('../../views/products/jumboSwine'))
  },

  {
    path: '/heroDog',
    component: lazy(() => import('../../views/products/heroDog'))
  },

  {
    path: '/wonderCat',
    component: lazy(() => import('../../views/products/wonderCat'))
  },

  {
    path: '/rawMaterial',
    component: lazy(() => import('../../views/products/rawMaterial'))
  },

  {
    path: '/news',
    component: lazy(() => import('../../views/information/News'))
  },

  {
    path: '/articles',
    component: lazy(() => import('../../views/information/Articles'))
  },

  {
    path: '/Job',
    component: lazy(() => import('../../views/information/Job'))
  },

  {
    path: '/magazine',
    component: lazy(() => import('../../views/information/Magazine'))
  },

  {
    path: '/quality',
    component: lazy(() => import('../../views/quality/QualityPage'))
  },

  {
    path: '/certificate',
    component: lazy(() => import('../../views/information/Certificate'))
  },

  {
    path: '/aboutUs',
    component: lazy(() => import('../../views/about/AboutPage'))
  },

  {
    path: '/feedMill',
    component: lazy(() => import('../../views/about/AboutFeedMill'))
  },

  {
    path: '/complain',
    component: lazy(() => import('../../views/about/AboutComplain'))
  },

  {
    path: '/contact',
    component: lazy(() => import('../../views/about/AboutContact'))
  },

  {
    path: '/cookie',
    component: lazy(() => import('../../views/about/AboutCookie'))
  },

  {
    path: '/privacy',
    component: lazy(() => import('../../views/about/AboutPrivate'))
  },

  {
    path: '/privacy1',
    component: lazy(() => window.location.href("https://www.google.com"))
  },

  {
    path: '/cookie1',
    component: lazy(() => window.location.href("https://www.google.com"))
  },

  {
    path: '/privacypolicy',
    component: lazy(() => window.location.href("https://www.google.com"))
  },

  {
    path: '/corporategovernance',
    component: lazy(() => window.location.href("https://www.google.com"))
  },

  {
    path: '/terms',
    component: lazy(() => import('../../views/about/AboutTerms'))
  },

  {
    path: '/qualitypolicy',
    component: lazy(() => import('../../views/about/AboutPolicyDCC'))
  },

  {
    path: '/app',
    component: lazy(() => import('../../views/test/App'))
  },

  {
    path: '/articles1',
    component: lazy(() => import('../../views/articles/Articles1'))
  },

  {
    path: '/articles2',
    component: lazy(() => import('../../views/articles/Articles2'))
  },

  {
    path: '/articles3',
    component: lazy(() => import('../../views/articles/Articles3'))
  },

  {
    path: '/articles4',
    component: lazy(() => import('../../views/articles/Articles4'))
  },

  {
    path: '/articles5',
    component: lazy(() => import('../../views/articles/Articles5'))
  },

  {
    path: '/articles6',
    component: lazy(() => import('../../views/articles/Articles6'))
  },

  {
    path: '/articles7',
    component: lazy(() => import('../../views/articles/Articles7'))
  },

  {
    path: '/articles8',
    component: lazy(() => import('../../views/articles/Articles8'))
  },

  {
    path: '/articles9',
    component: lazy(() => import('../../views/articles/Articles9'))
  },

  {
    path: '/articles10',
    component: lazy(() => import('../../views/articles/Articles10'))
  },

  {
    path: '/articles11',
    component: lazy(() => import('../../views/articles/Articles11'))
  },

  {
    path: '/articles12',
    component: lazy(() => import('../../views/articles/Articles12'))
  },

  {
    path: '/articles13',
    component: lazy(() => import('../../views/articles/Articles13'))
  },

  {
    path: '/articles14',
    component: lazy(() => import('../../views/articles/Articles14'))
  },

  {
    path: '/articles15',
    component: lazy(() => import('../../views/articles/Articles15'))
  },

  {
    path: '/articles16',
    component: lazy(() => import('../../views/articles/Articles16'))
  },

  {
    path: '/articles17',
    component: lazy(() => import('../../views/articles/Articles17'))
  },

  {
    path: '/articles18',
    component: lazy(() => import('../../views/articles/Articles18'))
  },

  {
    path: '/articles19',
    component: lazy(() => import('../../views/articles/Articles19'))
  },

  {
    path: '/articles20',
    component: lazy(() => import('../../views/articles/Articles20'))
  },

  {
    path: '/articles21',
    component: lazy(() => import('../../views/articles/Articles21'))
  },
  {
    path: '/articles22',
    component: lazy(() => import('../../views/articles/Articles22'))
  },


  {
    path: '/second-page',
    component: lazy(() => import('../../views/SecondPage'))
  },

  {
    path: '/login',
    component: lazy(() => import('../../views/Login')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },

  {
    path: '/error',
    component: lazy(() => import('../../views/Error')),
    layout: 'BlankLayout'
  }

]


export { DefaultRoute, TemplateTitle, Routes }
